// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 48rem;
  background: var(--white);
  border-radius: 1.2rem;
  box-shadow: 0 1.6rem 3.2rem rgba(44, 39, 56, 0.04), 0 3.2rem 6.4rem rgba(44, 39, 56, 0.08);
  display: block;
}

.header {
  height: 5.6rem;
  color: var(--red);
  background: #fdebeb;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header .text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  letter-spacing: 0.005em;
}
.header .icon-cancel {
  font-size: 1.8rem;
  cursor: pointer;
}

.container {
  padding: 30px 0;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
}

.content {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.content .title {
  font-size: 2.4rem;
  line-height: 2.9rem;
  font-weight: 500;
  color: var(--black);
  width: 100%;
}
.content .desc {
  font-size: 1.6rem;
  line-height: 1.9rem;
  letter-spacing: 0.005em;
  color: var(--black);
  width: 100%;
  max-width: 287px;
  margin-top: 1rem;
}

.actions {
  display: flex;
  justify-content: center;
  padding: 18px 0 15px 0;
}
.actions button[app-fill-button] {
  width: 180px;
  height: 48px;
  font-weight: 500;
  font-size: 14px;
  line-height: 120%;
}
.actions button[app-fill-button] :focus-visible {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/shared/popups/error-popups/err5xx/errors5xx-popup.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,wBAAA;EACA,qBAAA;EACA,0FACE;EAEF,cAAA;AADF;;AAIA;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AADF;AAGE;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAIE;EACE,iBAAA;EACA,eAAA;AAFJ;;AAMA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAHF;AAKE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAHJ;AAME;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AALF;AAOE;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AALJ;AAOI;EACE,aAAA;AALN","sourcesContent":[":host {\n  width: 48rem;\n  background: var(--white);\n  border-radius: 1.2rem;\n  box-shadow:\n    0 1.6rem 3.2rem rgba(44, 39, 56, 0.04),\n    0 3.2rem 6.4rem rgba(44, 39, 56, 0.08);\n  display: block;\n}\n\n.header {\n  height: 5.6rem;\n  color: var(--red);\n  background: #fdebeb;\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  & .text {\n    font-size: 1.6rem;\n    line-height: 1.9rem;\n    letter-spacing: 0.005em;\n  }\n\n  & .icon-cancel {\n    font-size: 1.8rem;\n    cursor: pointer;\n  }\n}\n\n.container {\n  padding: 30px 0;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n  gap: 20px;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  & .title {\n    font-size: 2.4rem;\n    line-height: 2.9rem;\n    font-weight: 500;\n    color: var(--black);\n    width: 100%;\n  }\n\n  & .desc {\n    font-size: 1.6rem;\n    line-height: 1.9rem;\n    letter-spacing: 0.005em;\n    color: var(--black);\n    width: 100%;\n    max-width: 287px;\n    margin-top: 1rem;\n  }\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  padding: 18px 0 15px 0;\n\n  button[app-fill-button] {\n    width: 180px;\n    height: 48px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 120%;\n\n    :focus-visible {\n      outline: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
